import "owl.carousel";
import {Modal} from "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

require('./helper');
require('./custom-carousel');

const scrollToTopBtn = document.getElementById("scrollToTopBtn");

window.onscroll = function () {
    if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
    ) {
        scrollToTopBtn.style.display = "flex";
    } else {
        scrollToTopBtn.style.display = "none";
    }
};

scrollToTopBtn.addEventListener("click", function () {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
});

// Toggle Menu button
document.addEventListener("DOMContentLoaded", function () {
    let menuButton = document.getElementById("menu-button");
    let closeButton = document.getElementById("close-button");
    let menu = document.getElementById("small-menu");

    menuButton.addEventListener("click", function () {
        menu.classList.add("show");
        menuButton.style.display = "none";
        closeButton.style.display = "block";
    });

    closeButton.addEventListener("click", function () {
        menu.classList.remove("show");
        menuButton.style.display = "block";
        closeButton.style.display = "none";
    });
});
